import LESchoolData from './LESchoolData';

export default LESchoolData;
export { getSchoolCode } from './Routing';
